// extracted by mini-css-extract-plugin
export default {"wrapper":"ReadMoreText_wrapper__FZkoZ"};